import { gql } from '@apollo/client';
import classNames from 'classnames/bind';
import styles from './FeaturedImage.module.scss';
import { Image } from '@/components';
let cx = classNames.bind(styles);

export function FeaturedImage({ image, sizes }) {
	return image ? <Image className={cx('featuredImage')} fill={true} priority={true} sizes={sizes} image={image} loading="eager" objectFit="cover" objectPosition='center' /> : null;
}

FeaturedImage.fragments = {
	entry: gql`
		fragment FeaturedImageFragment on NodeWithFeaturedImage {
			featuredImage {
				node {
					id
					sourceUrl
					altText
					mediaDetails {
						width
						height
					}
				}
			}
		}
	`,
};
